'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'lightbulb-on';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f672';
var svgPathData = 'M464 192c0 38.4-15 73.2-39.5 99.1-21.3 22.4-44.9 54-53.3 92.9l-102.4 0c-8.4-39-32-70.5-53.3-92.9-24.5-25.9-39.5-60.7-39.5-99.1 0-79.5 64.5-144 144-144s144 64.5 144 144zM416 413.7C416 379.4 435.7 349 459.3 324.1 492 289.7 512 243.2 512 192 512 86 426 0 320 0S128 86 128 192c0 51.2 20 97.7 52.7 132.1 23.6 24.9 43.3 55.3 43.3 89.6l0 18.3c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-18.3zM312 144c13.3 0 24-10.7 24-24s-10.7-24-24-24c-48.6 0-88 39.4-88 88 0 13.3 10.7 24 24 24s24-10.7 24-24c0-22.1 17.9-40 40-40zM58.7 26.5c-11.9-5.9-26.3-1.1-32.2 10.7S25.4 63.5 37.3 69.5l32 16c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-32-16zm544 42.9c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-32 16c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l32-16zM24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0zm560 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0zM90.7 341.5c11.9-5.9 16.7-20.3 10.7-32.2s-20.3-16.7-32.2-10.7l-32 16c-11.9 5.9-16.7 20.3-10.7 32.2s20.3 16.7 32.2 10.7l32-16zm480-42.9c-11.9-5.9-26.3-1.1-32.2 10.7s-1.1 26.3 10.7 32.2l32 16c11.9 5.9 26.3 1.1 32.2-10.7s1.1-26.3-10.7-32.2l-32-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightbulbOn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;